export { default } from './TemplateRenderer';
export type { TemplateRendererProps } from './TemplateRenderer.types';
